import React, { createContext, useContext } from 'react';

export interface NavigateOptions {
  external?: boolean;
  replace?: boolean;
}

export interface NavigationContextType {
  navigate: (path: string, options?: NavigateOptions) => void;
}

// Default implementation that will be overridden by providers
export const defaultNavigate = (path: string, options?: NavigateOptions) => {
  if (options?.external) {
    window.open(path, '_blank');
  } else if (options?.replace) {
    window.location.replace(path);
  } else {
    window.location.href = path;
  }
};

export const NavigationContext = createContext<NavigationContextType>({
  navigate: defaultNavigate,
});

export const useNavigation = () => useContext(NavigationContext);

export const NavigationProvider: React.FC<{
  children: React.ReactNode;
  navigationImplementation?: NavigationContextType;
}> = ({ children, navigationImplementation }) => {
  return (
    <NavigationContext.Provider value={navigationImplementation || { navigate: defaultNavigate }}>
      {children}
    </NavigationContext.Provider>
  );
};
